import { useMemo } from 'react';
import { colors, Table, Text, ITableProps } from 'common-components';
import { ColumnsType } from 'antd/lib/table';
import { useNavigate } from 'react-router';
import { routes } from '@navigation/route-declarations';
import { ProjectAchievementType } from '@types';
import { useAppTranslation } from '@hooks';

type ContributionsTablePropsType = {
  projectsAchievement: ProjectAchievementType[]
  tableProps?: Partial<ITableProps<ProjectAchievementType>>
};
const ContributionsTable = ({
  projectsAchievement,
  tableProps = {},
}: ContributionsTablePropsType) => {
  const navigate = useNavigate();
  const { translate } = useAppTranslation();

  const tableColumns: ColumnsType<ProjectAchievementType> = useMemo(
    () => [
      {
        title: translate('contributions.table.projectName'),
        dataIndex: 'name',
        key: 'name',
        render: (name: ProjectAchievementType['name']) => (
          <Text size="xs" color={colors.gray900} style={{ fontWeight: 500 }}>
            {name}
          </Text>
        ),
      },
      /* HIDE
			{
				title: "Temps effectif",
				dataIndex: "effectiveTime",
				key: "effectiveTime",
				render: (effectiveTime) => <Row align={"middle"}>{effectiveTime}</Row>,
			},
			{
				title: "Volume",
				dataIndex: "nbHits",
				key: "nbHits",
				render: (volume) => <Row align={"middle"}>{volume}</Row>,
			},
			{
				title: "Qualité",
				dataIndex: "quality",
				key: "quality",
				render: (quality) => (
					<Row align={"middle"}>
						{!!quality && <DotComponent activeDots={quality} />}
					</Row>
				),
			},*/
    ],
    [],
  );

  const onRowClick = useMemo(
    () => (record: ProjectAchievementType) => ({
      onClick: (e: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => {
        if (
          // record.accessLevel !== 'noAccess' &&
          !['checkbox'].includes((e.target as HTMLInputElement).name)
        ) {
          navigate(routes.contribution.navigate(record.idProject));
        }
      },
    }),
    [navigate],
  );

  return (
    <Table onRow={onRowClick} data={projectsAchievement} rowKey="idProject" columns={tableColumns} {...tableProps} />
  );
};

export default ContributionsTable;
